module.exports = __webpack_public_path__ + "img/cap_04.a2847140.jpg";